module.exports = __webpack_public_path__ + "img/customer-icon-20.bb51c47a.png";